import styled from 'styled-components'
import Ex4 from "../imagens/foto17obra.jpg"

export const Main = styled.main`
background-color: #f7f7f7;
`
export const DivTitulo = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background: rgba(0,0,0,1);
background-image: url(${Ex4});
background-position: right;
height: 45vh;
box-shadow: inset 0 0 0 200px rgba(0,0,0,0.5);
color: white;
h1 {
    text-align: center;
    font-size: 3rem;
}
h2 {
    text-align: center;
    margin-top: 2.5rem;
    font-size: 2rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    h1 {
        font-size: 2.5rem;
        margin-top: 1rem;
    }
    h2 {
        font-size: 1.7rem;
        margin-top: 2rem;
    }
}
@media (min-width: 501px) and (max-width: 900px) {
box-shadow: inset 0 0 0 300px rgba(0,0,0,0.5);
}
`
export const Info = styled.section`
margin-top: 0.5rem;
margin-bottom: 0.5rem;
display: flex;
justify-content: space-evenly;
align-items: top;
@media (min-width: 201px) and (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
}
@media (min-width: 501px) and (max-width: 900px) {
    margin-top: 1rem;
}
`
export const DivInfo = styled.div`
background-color: #eaeaea;
width: 40%;
border-radius: 5px;
box-shadow: 1px 1px 5px;
@media (min-width: 201px) and (max-width: 500px) {
    margin-top: 0.5rem;
    width: 90%;
}
@media (min-width: 501px) and (max-width: 900px) {
   width: 45%;
}
`
export const DivInfoConcreto = styled.div`
width: 40%;
height: 40vh;
border-radius: 5px;
box-shadow: 1px 1px 5px;
@media (min-width: 201px) and (max-width: 500px) {
    margin-top: 0.5rem;
    width: 90%;
    height: 35vh;
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 45%;
    height: 25vh;
}
`
export const DivInfoTitle = styled.div`
border-radius: 5px 5px 0 0;
margin-left: 0.5rem;
margin-bottom: 0.25rem;
h3 {
    font-size: 1.5rem;
}
p {
    font-size: 1.1rem;
    opacity: 0.6;
}
`
export const DivInfoCustoBeneficio = styled.div`
background-color: #ffffff;
border-radius: 5px 5px 0 0;
`
export const DivInfos = styled.div`
display: flex;
gap: 5px;
align-items: center;
p {
    font-size: 1.05rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    p {
        font-size: 0.7rem;
    }
    svg {
        width: 16px;
    }
}
@media (min-width: 501px) and (max-width: 900px) {
   p {
    font-size: 0.75rem;
   }
   svg {
    width: 20px;
   }
}
`
export const DivInfosReparo = styled.div`
p {
    font-size: 1.05rem;
}
li {
    font-size: 1.05rem;
}
ul {
    padding-left: 2rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    p {
        font-size: 0.7rem;
    }
    svg {
        width: 16px;
    }
    li {
    font-size: 0.7rem;
    }
}
`
export const DivReparo = styled.div`
display: flex;
align-items: center;
gap: 5px;
`
export const Beneficios = styled.section`
margin-top: 1rem;
display: flex;
flex-direction: column;
align-items: center;
background-color: white;
gap: 20px;
h2 {
    font-size: 2rem;
}
`
export const DivBeneficios = styled.div`
display: flex;
justify-content: space-evenly;
align-items: center;
width: 100%;
@media (min-width: 201px) and (max-width: 500px) {
    flex-direction: column;
}
`
export const DivBeneficio = styled.div`
text-align: center;
display: flex;
flex-direction: column;
justify-content: space-evenly;
align-items: center;
box-shadow: 1px 3px 4px 0.5px #9d9d9d;
border-radius: 5px;
width: 25vw;
height: 20vh;
margin-bottom: 2rem;
h3 {
    font-size: 1.5rem;
}
p {
    font-size: 1.1rem;
}
div {
    background-color: #c5c5c5;
    border-radius: 20px;
    width: 9%;
    height: 22%;
}
@media (min-width: 201px) and (max-width: 500px) {
    width: 75%;
    div {
        width: 11%;
        height: 19%;
    }
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 30%;
    h3 {
    font-size: 1.3rem;
}
    p {
    font-size: 1rem;
}
div {
    width: 14%;
    height: 13%;
}
}
`